(function () {
  'use strict';

  var STORE_KEY = 'dyTWPWHRtgBJaLR8TpNmjUqO5K8g1xIiNGci0Bt8';
  var API_ROOT = 'https://api-cdn.yotpo.com/v3/storefront/store/' + STORE_KEY + '/product/';
  var scanQueued = false;

  function parseReviewCount(text) {
    var match = String(text || '').match(/[\d,]+/);
    return match ? Number(match[0].replace(/,/g, '')) : 0;
  }

  function formatCount(count) {
    return Number(count || 0).toLocaleString(document.documentElement.lang || 'en');
  }

  function formatReviewDate(value) {
    var text = String(value || '').trim();
    var dayFirst = text.match(/^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{2}|\d{4})$/);
    var yearFirst = text.match(/^(\d{4})[\/.\-](\d{1,2})[\/.\-](\d{1,2})$/);
    var day;
    var month;
    var year;

    if (dayFirst) {
      day = Number(dayFirst[1]);
      month = Number(dayFirst[2]);
      year = Number(dayFirst[3]);
    } else if (yearFirst) {
      year = Number(yearFirst[1]);
      month = Number(yearFirst[2]);
      day = Number(yearFirst[3]);
    } else {
      return text;
    }

    if (year < 100) year += 2000;
    if (month < 1 || month > 12 || day < 1 || day > 31 || typeof Intl === 'undefined') return text;

    var date = new Date(Date.UTC(year, month - 1, day));
    if (
      date.getUTCFullYear() !== year
      || date.getUTCMonth() !== month - 1
      || date.getUTCDate() !== day
    ) {
      return text;
    }

    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC'
      }).format(date);
    } catch (error) {
      return text;
    }
  }

  function preferredScrollBehavior() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
  }

  function formatReviewDates(scope) {
    scope.querySelectorAll('.yotpo-date-format').forEach(function (dateElement) {
      var formatted = formatReviewDate(dateElement.textContent);

      if (formatted && formatted !== dateElement.textContent.trim()) {
        dateElement.textContent = formatted;
      }
    });
  }

  function removeGeneratedReviewSummary(scope) {
    scope.querySelectorAll('#yotpo-reviews-section-data').forEach(function (summary) {
      summary.remove();
    });

    scope.querySelectorAll('.yotpo-paragraph-summary-container').forEach(function (summary) {
      summary.remove();
    });
  }

  function activateControl(element) {
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (eventName) {
      var EventConstructor = eventName.indexOf('pointer') === 0 && window.PointerEvent
        ? window.PointerEvent
        : window.MouseEvent;
      element.dispatchEvent(new EventConstructor(eventName, {
        bubbles: true,
        cancelable: true,
        pointerType: 'mouse',
        view: window
      }));
    });
  }

  function createRatingRows() {
    var rows = '';

    for (var rating = 5; rating >= 1; rating -= 1) {
      rows += '<button class="dbx-reviews-snapshot__row" type="button" data-review-filter="' + rating + '" aria-pressed="false" aria-label="Filter reviews to ' + rating + ' stars">'
        + '<span class="dbx-reviews-snapshot__label">' + rating + ' star' + (rating === 1 ? '' : 's') + '</span>'
        + '<span class="dbx-reviews-snapshot__track" aria-hidden="true"><span class="dbx-reviews-snapshot__fill" data-rating-fill="' + rating + '"></span></span>'
        + '<span class="dbx-reviews-snapshot__count" data-rating-count="' + rating + '">–</span>'
        + '</button>';
    }

    return rows;
  }

  function createReviewStars() {
    var stars = '';

    for (var rating = 1; rating <= 5; rating += 1) {
      stars += '<button class="dbx-reviews-write__star" type="button" data-review-score="' + rating + '" aria-label="Start a ' + rating + '-star review">★</button>';
    }

    return stars;
  }

  function createOverview() {
    var overview = document.createElement('section');
    overview.className = 'dbx-reviews-overview';
    overview.setAttribute('aria-labelledby', 'dbx-reviews-title');
    overview.innerHTML = ''
      + '<div class="dbx-reviews-overview__heading">'
      + '  <h2 id="dbx-reviews-title">Ratings &amp; Reviews</h2>'
      + '  <p>Feedback from customers who put DUXBUX gear to work.</p>'
      + '</div>'
      + '<div class="dbx-reviews-overview__grid">'
      + '  <section class="dbx-reviews-snapshot" aria-labelledby="dbx-rating-snapshot-title">'
      + '    <h3 id="dbx-rating-snapshot-title">Rating snapshot</h3>'
      + '    <p>Select a row to filter customer reviews.</p>'
      + '    <div class="dbx-reviews-snapshot__rows">' + createRatingRows() + '</div>'
      + '  </section>'
      + '  <section class="dbx-reviews-overall" aria-labelledby="dbx-overall-rating-title">'
      + '    <h3 id="dbx-overall-rating-title">Overall rating</h3>'
      + '    <div class="dbx-reviews-overall__score-row">'
      + '      <strong class="dbx-reviews-overall__score" data-overall-score hidden></strong>'
      + '      <div class="dbx-reviews-overall__detail">'
      + '        <span class="dbx-reviews-overall__stars" data-overall-stars role="img" aria-label="Rating unavailable"><span aria-hidden="true">★★★★★</span></span>'
      + '        <button type="button" class="dbx-reviews-overall__count" data-review-count>Loading reviews…</button>'
      + '      </div>'
      + '    </div>'
      + '    <p class="dbx-reviews-overall__note" data-overall-note>Ratings are collected through Yotpo.</p>'
      + '  </section>'
      + '  <section class="dbx-reviews-write" aria-labelledby="dbx-review-product-title">'
      + '    <h3 id="dbx-review-product-title">Review this product</h3>'
      + '    <div class="dbx-reviews-write__stars" aria-label="Choose a rating to begin your review">' + createReviewStars() + '</div>'
      + '    <p>Adding a review requires a valid email for verification.</p>'
      + '  </section>'
      + '</div>';

    return overview;
  }

  function updateOverview(overview, bottomline) {
    var total = Number(bottomline.totalReview || bottomline.totalReviews || 0);
    var hasReviews = total > 0;
    var score = Number(bottomline.averageScore || 0);
    var distribution = bottomline.starDistribution || {};
    var scoreText = hasReviews ? score.toFixed(1).replace(/\.0$/, '') : '';
    var percent = total ? Math.max(0, Math.min(100, score / 5 * 100)) : 0;
    var scoreElement = overview.querySelector('[data-overall-score]');
    var starsElement = overview.querySelector('[data-overall-stars]');
    var countElement = overview.querySelector('[data-review-count]');
    var noteElement = overview.querySelector('[data-overall-note]');
    var snapshotElement = overview.querySelector('.dbx-reviews-snapshot');

    overview.classList.toggle('dbx-reviews-overview--empty', !hasReviews);
    if (snapshotElement) snapshotElement.hidden = !hasReviews;

    scoreElement.hidden = !hasReviews;
    scoreElement.textContent = scoreText;
    starsElement.style.setProperty('--review-score', percent + '%');
    starsElement.setAttribute('aria-label', total ? scoreText + ' out of 5 stars' : 'No ratings yet');
    countElement.textContent = total === 1 ? '1 review' : formatCount(total) + ' reviews';
    countElement.disabled = !hasReviews;
    noteElement.textContent = total
      ? 'Based on ' + formatCount(total) + ' customer review' + (total === 1 ? '' : 's') + '.'
      : 'Be the first to review this product.';

    for (var rating = 1; rating <= 5; rating += 1) {
      var count = Number(distribution[rating] || 0);
      var width = total ? count / total * 100 : 0;
      var fill = overview.querySelector('[data-rating-fill="' + rating + '"]');
      var countLabel = overview.querySelector('[data-rating-count="' + rating + '"]');

      fill.style.width = width + '%';
      countLabel.textContent = formatCount(count);
    }
  }

  function readBottomlineFromWidget(root) {
    var scoreElement = root.querySelector('.yotpo-bottom-line-score');
    var countElement = root.querySelector('.yotpo-bottom-line-basic-text');

    return {
      totalReview: parseReviewCount(countElement ? countElement.textContent : ''),
      averageScore: scoreElement ? Number(scoreElement.textContent.trim()) : 0,
      starDistribution: {}
    };
  }

  function openReviewForm(root, score) {
    var writeButton = root.querySelector('.yotpo-new-review-btn');
    if (!writeButton) return;

    writeButton.click();

    var attempts = 0;
    var selectScore = function () {
      var input = document.getElementById('yotpo_star_rating_' + score);
      var label = document.querySelector('label[for="yotpo_star_rating_' + score + '"]');

      if (input) {
        input.click();
        if (label) label.focus();
        return;
      }

      attempts += 1;
      if (attempts < 30) window.setTimeout(selectScore, 50);
    };

    selectScore();
  }

  function filterReviews(root, overview, rating) {
    var filter = root.querySelector('.yotpo-score-filter-container');
    var toggle = filter && filter.querySelector('.yotpo-dropdown-closable');
    if (!filter || !toggle) return;

    toggle.click();

    window.setTimeout(function () {
      var options = Array.prototype.slice.call(filter.querySelectorAll('.yotpo-dropdown-option'));
      var option = options.find(function (candidate) {
        return candidate.textContent.trim().indexOf(rating + ' star') !== -1;
      });

      if (!option) return;
      activateControl(option);

      overview.querySelectorAll('[data-review-filter]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-review-filter') === String(rating)));
      });
    }, 0);
  }

  function bindOverview(overview, root) {
    overview.addEventListener('click', function (event) {
      var ratingFilter = event.target.closest('[data-review-filter]');
      var reviewStar = event.target.closest('[data-review-score]');
      var reviewCount = event.target.closest('[data-review-count]');

      if (ratingFilter) {
        filterReviews(root, overview, Number(ratingFilter.getAttribute('data-review-filter')));
      } else if (reviewStar) {
        openReviewForm(root, Number(reviewStar.getAttribute('data-review-score')));
      } else if (reviewCount && !reviewCount.disabled) {
        var reviews = root.querySelector('.yotpo-filters-container, .yotpo-reviews-container');
        if (reviews) reviews.scrollIntoView({ behavior: preferredScrollBehavior(), block: 'start' });
      }
    });
  }

  function initializeInstance(instance) {
    if (instance.getAttribute('data-dbx-reviews-ready') === 'true') return;

    var root = instance.querySelector('#yotpo-reviews-main-widget');
    var productId = instance.getAttribute('data-yotpo-product-id');
    var writeButton = root && root.querySelector('.yotpo-new-review-btn');

    if (!root || !productId || !writeButton) return;

    var overview = createOverview();
    instance.insertBefore(overview, root);
    instance.setAttribute('data-dbx-reviews-ready', 'true');
    instance.classList.add('dbx-reviews-ready');
    bindOverview(overview, root);
    updateOverview(overview, readBottomlineFromWidget(root));

    fetch(API_ROOT + encodeURIComponent(productId) + '/reviews?page=1&perPage=1&sort=smart,date,images,badge,rating')
      .then(function (response) {
        if (!response.ok) throw new Error('Yotpo ratings request failed');
        return response.json();
      })
      .then(function (data) {
        if (data && data.bottomline) updateOverview(overview, data.bottomline);
      })
      .catch(function () {
        overview.classList.add('dbx-reviews-overview--fallback');
      });
  }

  function scan() {
    scanQueued = false;
    removeGeneratedReviewSummary(document);

    document.querySelectorAll('.yotpo-widget-instance[data-yotpo-product-id]').forEach(function (instance) {
      initializeInstance(instance);
      formatReviewDates(instance);
    });
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(scan);
  }

  function initialize() {
    queueScan();

    document.addEventListener('click', function (event) {
      var summaryTrigger = event.target.closest('.anchor-yotpo');
      var overview = document.querySelector('.dbx-reviews-overview');

      if (!summaryTrigger || !overview) return;
      event.preventDefault();
      event.stopPropagation();
      overview.scrollIntoView({ behavior: preferredScrollBehavior(), block: 'start' });
    }, true);

    if ('MutationObserver' in window) {
      new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', queueScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
}());
